<template>
  <div>
    <v-menu v-if="!is_date_type_month && !is_date_time_type" ref="date_menu" v-model="date_menu" :return-value.sync="date_pick" :close-on-content-click="false" min-width="320px" max-width="350px" nudge-bottom="10">
      <template v-slot:activator="{ on }">
        <v-text-field dense outlined :label="label" :prepend-icon="!inner_icon ? 'mdi-calendar' : ''" :prepend-inner-icon="inner_icon ? 'mdi-calendar' : '' " readonly v-on="on"
          :value="show_formated_date" :rules="required_date ? required : []"
          :disabled="is_readonly"
        ></v-text-field>
      </template>
      <v-date-picker dense 
        :active-picker.sync="activePicker"
        v-if="!is_readonly" 
        :readonly="is_component_create_event ? false : is_readonly" 
        :show-current="show_current" 
        v-model="date_pick" 
        no-title 
        scrollable 
        full-width 
        :min="min || min_date" 
        :max="max"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="date_menu = false">Cancelar</v-btn>
      </v-date-picker>
    </v-menu>
    
    <v-menu v-if="is_date_time_type" ref="date_time_menu" v-model="date_menu" :close-on-content-click="false" bottom offset-y nudge-bottom="-26">
      <template v-slot:activator="{ on }">
        <v-text-field dense outlined :label="label" prepend-icon="mdi-calendar" readonly v-on="on"
          :value="show_formated_date" :rules="required_date ? required : []" style="width: 90%;margin: auto;"
        ></v-text-field>
      </template>
        <v-card>
          <date-picker inline v-model="date_pick" type="datetime" :show-second="false" style="overflow: hidden; padding-bottom: 10px"></date-picker>
        </v-card>
    </v-menu>

    <v-menu v-if="is_date_type_month" ref="date_month_menu" :default-value="$dayjs(date).format('YYYY-MM-DDTHH:mm:ss')+'.000Z'" v-model="date_menu" :close-on-content-click="true" min-width="320px" max-width="350px" nudge-bottom="10" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn small v-on="on" :color="is_component_used_in_all_events ? 'black' : 'black'" text :class="is_component_used_in_all_events ? 'mx-2 mb-2' : 'mx-2 mb-2 title-financial btn-primary'">{{is_component_used_in_all_events ? label+month_name : month_name}}<v-icon right>mdi-arrow-down</v-icon></v-btn>
      </template>
      <v-date-picker
        v-model="date_pick"
        type="month"
        no-title scrollable full-width dense
        value-type="format"
        format="YYYY-MM-DD HH:mm:ss"
        :events="month_events"
        event-color="primary"
      >
      </v-date-picker>
    </v-menu> 
  </div>
</template>

<script>
  import validations from "@/mixins/validations";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/pt-br';
  export default {
    name: 'CalendarDatePicker',
    mixins: [ validations ],
    components: {
      DatePicker
    },
    props: {
      is_component_used_in_all_events: {
        type: Boolean,
        default: ()=>false
      },
      is_date_type_month: {
        type: Boolean,
        default: ()=>false
      },
      is_date_time_type: {
        type: Boolean,
        default: ()=>false
      },
      item: {
        type: Object, 
      },
      label: {
        type: String, 
      },
      max: {
        type: String, 
      },
      min: {
        type: String, 
      },
      show_current: {
        type: String
      },
      is_component_show_event: {
        type: Boolean
      },
      is_component_create_event: {
        type: Boolean
      },
      is_readonly: {
        type: Boolean
      },
      date: {
        type: String
      },
      active_picker: {
        type: String,
        default: undefined
      },
      required_date: {
        type: Boolean,
        default: ()=> true
      },
      dense:{
        type: Boolean,
        default: false,
      },
      outlined:{
        type: Boolean,
        default: false,
      },
      inner_icon:{
        type: Boolean,
        default: false,
      },
      month_events: {
        type: Array,
        default: () => []
      },
      disabled_input: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        activePicker: null,
        date_pick: '',
        date_menu: false,
        min_date: null,
      }
    },
    mounted() {
      this.setDate()
    },
    computed: {
      month_name(){
        return this.date_pick ? this.$dayjs(this.date_pick).format('MMMM').substring(0,3)+this.$dayjs(this.date_pick).format('/YY') : this.$dayjs().format('MMMM').substring(0,3)+this.$dayjs().format('/YY')
      },
      show_formated_date(){
        if(this.is_date_time_type){
          return this.date_pick ? this.$dayjs(this.date_pick).format("DD")+' de '+this.$dayjs(this.date_pick).format("MMMM, HH:mm") : ''
        }else{
          return this.date_pick != '' ? this.$dayjs(this.date_pick).add(12,'hour').format('DD/MM/YYYY') : null
        }
      },
    },
    methods: {
      setDate(){
        if((this.is_component_show_event && this.date) || (this.is_date_time_type && this.date)){
          this.date_pick = this.date
        }
      },
    },
    watch: {
      date_menu(val) {
        if(this.active_picker == 'YEAR'){
          val && setTimeout(() => (this.activePicker = 'YEAR'))
        }
      },
      date_pick(nV) {
        if(this.item){
          if(this.is_date_type_month){
            this.$refs.date_month_menu.save(nV)
          }else if(!this.is_date_time_type && !this.is_date_type_month){
            this.$refs.date_menu.save(nV)
          }
          let item = {...this.item}
          item.date = nV
          this.$emit('datePicked', item )
        }else{
          if(this.is_date_type_month){
            this.$refs.date_month_menu.save(nV)
          }else if(!this.is_date_time_type && !this.is_date_type_month){
            this.$refs.date_menu.save(nV)
          }
          this.$emit('datePicked', nV )
        }
      },
      max(){
        if(this.$dayjs(this.date_pick).isAfter(this.max)){
          this.date_pick = ''
        }
      },
      min(){
        if(this.$dayjs(this.date_pick).isBefore(this.min)){
          this.date_pick = ''
        }
      },
      date(nv) {
        this.setDate()
      }
    },    
  }
</script>

<style lang="scss">
  .mx-input{
    border-collapse: collapse!important;;
    border-color: #999!important;;
    border-style: solid!important;;
    border-width: 1px!important;;
  }

  .mx-datepicker-main {
    border: 0px solid #e8e8e8; 
  }

  .tab-transition {
    background-color: red;
  }
</style>